module.exports = __webpack_public_path__ + "static/media/comment7_2.04d5cd46.png";